export enum EIntegrationStep {
  GET_STARTED = 'GET_STARTED',
  AUTHORIZE_CONNECTION = 'AUTHORIZE_CONNECTION',
}
